import { Controller } from "@hotwired/stimulus";

export default class extends Controller {
  connect() { }

  enter() {
    return false;

    console.log("FROM CONTROLLER!!!!")
  }
}
